import React from 'react';
import { toastr } from 'react-redux-toastr';
import { Link } from 'react-router-dom';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { reset } from 'redux-form';

export const ADD_CUSTOMER_ACCOUNT_REQUEST = 'ADD_CUSTOMER_ACCOUNT_REQUEST';
export const ADD_CUSTOMER_ACCOUNT_SUCCESS = 'ADD_CUSTOMER_ACCOUNT_SUCCESS';
export const ADD_CUSTOMER_ACCOUNT_FAILURE = 'ADD_CUSTOMER_ACCOUNT_FAILURE';
export const ADD_CUSTOMER_ACCOUNT_CLEAR_CUSTOMER = 'ADD_CUSTOMER_ACCOUNT_CLEAR_CUSTOMER';
export const ADD_CUSTOMER_ACCOUNT_CLEAR_ACCOUNT = 'ADD_CUSTOMER_ACCOUNT_CLEAR_ACCOUNT';

function request() {
  return {
    type: ADD_CUSTOMER_ACCOUNT_REQUEST,
    isAddingCustomerAccount: true,
  };
}

function clear() {
  toastr.removeByType('confirm');
  return {
    type: ADD_CUSTOMER_ACCOUNT_SUCCESS,
    isAddingCustomerAccount: false,
    addCustomerAccountErrors: []
  };
}

function requestClearAccount() {
  return {
    type: ADD_CUSTOMER_ACCOUNT_CLEAR_ACCOUNT
  };
}

function requestClearCustomer() {
  return {
    type: ADD_CUSTOMER_ACCOUNT_CLEAR_CUSTOMER
  };
}

function reject(addCustomerAccountErrors) {
  return {
    type: ADD_CUSTOMER_ACCOUNT_FAILURE,
    isAddingCustomerAccount: false,
    addCustomerAccountErrors
  };
}

function ErrorItem(error) {
  return error && <li key={ error }>{ error }</li>;
}

const ResultToastr = (result) => {
  const { success, errors, customerDbId, accountDbId, customerId, accountNumber, newCustomer, newAccount } = result;
  const idsGiven = customerDbId > 0 && accountDbId > 0;
  return (<div className="customer-account-form-confirm">
    { (!result || (!success && !idsGiven)) && <h1>Missing/incorrect data</h1> }
    { (success || (idsGiven)) && <h1>Success</h1> }
    <hr />
    { (success || idsGiven) && <p>
      Shareholder:{'\u00A0'}
      <Link
        className="btn btn-link"
        to={ `/customer/${ customerDbId }` }
      >{customerId}</Link>
      {'\u00A0'}and Account:{'\u00A0'}
      <Link
        className="btn btn-link"
        to={ `/account/${ accountDbId }` }
      >{accountNumber}</Link>
      {'\u00A0'}successfully { newCustomer || newAccount ? 'created &' : '' } linked.
    </p> }
    { idsGiven && errors && <h3>Notices:</h3>}
    { (!success || errors) && <p>
      { errors && errors.split(/\n/).map(ErrorItem) }
    </p> }
  </div>);
};

export function clearForm(selectionValue) {
  return (dispatch) => {
    dispatch(clear(selectionValue));
    dispatch(reset('addCustomerAccount'));
  };
}

export function clearSelectedCustomer() {
  return (dispatch) => {
    dispatch(requestClearCustomer());
  };
}

export function clearSelectedAccount() {
  return (dispatch) => {
    dispatch(requestClearAccount());
  };
}

export function addCustomerAccount(data) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .addCustomerAccount(data)
      .then((response) => {
        const toastOptions = {
          id: 'add-confirm',
          disableCancel: true,
          component: () => (<ResultToastr result={ { success: false, errors: 'There was a problem processing your request.' } } />)
        };
        if (response.data) {
          if (response.data.success === true) {
            dispatch(clearForm());
          }
          toastOptions.component = () => (<ResultToastr { ...response.data } />);
        }
        toastr.confirm(null, toastOptions);
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
